import React, { useContext } from 'react'
import { ObjectDebug } from 'components/Util/ObjectDebug'
import { AuthContext } from 'components/Auth/Auth'

const AuthDebug = () => {
    const auth = useContext(AuthContext)

    if (auth.almaAuthError) {
        return (
            <ObjectDebug
                title="Auth0 - almaAuthError"
                object={auth.verifyMapAlmaUserResponseError}
            />
        )
    }

    if (auth.verifyMapAlmaUserResponseError) {
        return (
            <ObjectDebug
                title="Auth0 - verifyMapAlmaUserResponseError"
                object={auth.verifyMapAlmaUserResponseError}
            />
        )
    }

    if (!auth.almaAuthData) {
        return (
            <ObjectDebug
                title="Auth0 - no session"
                object="No Auth0 session"
            />
        )
    }

    return (
        <ObjectDebug
            title="Auth0 - data"
            object={auth.almaAuthData}
        />
    )
}

export default AuthDebug
